import { Button, Divider, List, Stack, Typography } from '@mui/material';
import React from 'react';
import AppointmentDateRange from './AppointmentDateRange';

interface AppointmentListPanelProps {
    startDate: Date;
    endDate: Date;
    appointmentList: React.ReactNode[];
    onAddToList: () => void;
    callItemCount: number;
}

const AppointmentListPanel: React.FC<AppointmentListPanelProps> = ({ startDate, endDate, appointmentList, onAddToList, callItemCount }) => (
    <Stack spacing={2}>
        <AppointmentDateRange startDate={startDate} endDate={endDate} />
        <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1}>
            <Typography variant="body1" fontWeight={700}>
                Call List:
            </Typography>
            <Typography textAlign={'right'} fontWeight={700} variant="body1">
                {callItemCount}
            </Typography>
        </Stack>
        <Button variant="contained" color="primary" fullWidth sx={{ marginY: 2 }} onClick={onAddToList}>
            Add to Call List
        </Button>
        <Divider />
        <List dense>{React.Children.toArray(appointmentList)}</List>
    </Stack>
);

export default AppointmentListPanel;
